/* eslint-disable react/no-unknown-property */
import { Helmet } from "react-helmet";
import { useEffect } from "react";

const CallBotSDK = () => {
  useEffect(() => {
    return () => {
      // Xóa widget và các elements ChatMe tạo ra
      const callmeSelectors = [
        ".callme-widget",
        '[class*="callme"]',
        '[id*="callme"]',
        '[class*="cm-"]',
        '[id*="cm-"]',
        'iframe[src*="chatme"]',
        "div[data-callme]",
      ];

      callmeSelectors.forEach((selector) => {
        const elements = document.querySelectorAll(selector);
        elements.forEach((el) => {
          if (el.parentNode) {
            el.parentNode.removeChild(el);
          }
        });
      });
    };
  }, []);

  return (
    <Helmet>
      <script
        src="https://robot.chatme.vn/cm.js"
        data-callme-id="2b3537ee395b403d7875b21465c2043a"
        right="124px"
        bottom="40px"
        async
      ></script>
    </Helmet>
  );
};

export default CallBotSDK;
